import { productFacts } from './productFacts';

type FaqItem = {
  id: string;
  question: string;
  answer: string;
};

export const homepageFaqs: FaqItem[] = [
  {
    id: 'what-is',
    question: 'What is Chat.co?',
    answer: productFacts.description,
  },
  {
    id: 'train',
    question: 'How do I train my agent?',
    answer:
      'Upload documents (PDF, Word, Excel/CSV), crawl your website, or add text and Q&A pairs. Integrations like YouTube transcripts and Freshdesk content are also supported, and training data can be in any language.',
  },
  {
    id: 'models',
    question: 'Which AI models are supported?',
    answer:
      "10+ leading models across providers, including OpenAI's ChatGPT, Anthropic's Claude, and Google's Gemini. Switch models anytime and tune settings like temperature without retraining your knowledge.",
  },
  {
    id: 'deploy',
    question: 'How do I deploy my agent on my website?',
    answer:
      'Paste a JavaScript embed code into your site, embed via iFrame on specific pages, share a direct link, or generate a QR code. Developers can also integrate through the API.',
  },
  {
    id: 'security',
    question: 'How is my data protected?',
    answer:
      "SA CYBER LLC's information security management system supporting Chat.co is certified to ISO/IEC 27001:2022 (Certificate GCAI-ISMS-LM73), valid through August 28, 2029. Data is encrypted with AES-256 at rest and TLS 1.2+ in transit, with JWT authentication and role-based access control. We align with GDPR and CCPA, and our SOC 2 Type II audit is currently in progress.",
  },
  {
    id: 'plans',
    question: 'What subscription plans are available?',
    answer:
      productFacts.trial +
      ' Paid plans include Starter, Pro, Business, and Enterprise. See the homepage pricing section for current prices, limits, and model access.',
  },
  {
    id: 'languages',
    question: 'Can my agent answer in multiple languages?',
    answer:
      "Yes. Agents detect the user's language in real time and respond accordingly, and you can train on source documents in any language.",
  },
  {
    id: 'api',
    question: 'Is there an API?',
    answer:
      'Yes. Generate and manage API keys from your account settings to integrate agents into your own applications and workflows.',
  },
];
